import { render, staticRenderFns } from "./TrendsNum.vue?vue&type=template&id=172aff84&scoped=true"
import script from "./TrendsNum.vue?vue&type=script&lang=js"
export * from "./TrendsNum.vue?vue&type=script&lang=js"
import style0 from "./TrendsNum.vue?vue&type=style&index=0&id=172aff84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172aff84",
  null
  
)

export default component.exports